import React from 'react'; // Add missing import statement
import moment from 'moment';
import { Link } from 'react-router-dom';
import { NumberFormat } from "../../Components/NumberFormat";
const { $ } = window;
const WithdrawalListDetail = (state) => {
    const hideModal = () => {
        $('#modalWithdrawalListDetail').modal('hide');
        
    }
    return (
        <div className="container-fluid" style={{padding: '37px'}}>
            <div className="row">
                <div className="col-md-12" style={{alignContent:'center', paddingBottom: '27px'}}>
                    <h4>Withdrawal List Detail</h4>
                </div>
                <div style={{position:'absolute', right: '17px', top: '17px'}}><Link style={{textDecoration: 'none'}}><h5 onClick={hideModal}>X</h5></Link></div>
            </div>
            <div className="row">Transaction ID: {state.withdrawalListDetail.id}</div>
            <div className="row">More SO Number: {state.withdrawalListDetail.reference_id}</div>
            <div className="row">Created Date: {moment(state.withdrawalListDetail.created).format('DD MMMM YYYY HH:mm:ss')}</div>
            <div className="row">Transaction Type: {state.withdrawalListDetail.type}</div>
            <div className="row">Transaction Status: {state.withdrawalListDetail.settlement_status}</div>
            <div className="row">Paid Date: {moment(state.withdrawalListDetail.estimated_settlement_time).format('DD MMMM YYYY HH:mm:ss')}</div>
            <div className="row">Channel Method: {state.withdrawalListDetail.channel_method}</div>
            <div className="row">Channel Category: {state.withdrawalListDetail.channel_category}</div>
            <div className="row">Amount (IDR): {NumberFormat(state.withdrawalListDetail.amount)}</div>
            <div className="row">Net Amount (IDR): {NumberFormat(state.withdrawalListDetail.amount)}</div>
        </div>

    );
}

export default WithdrawalListDetail;